import { NativeAudio } from '@capacitor-community/native-audio';
import { Capacitor } from '@capacitor/core';

export enum SoundIds {
  BEEP = 'BEEP',
  HOOYAH = 'HOOYAH',
}

interface Sound {
  androidPath: string;
  webPath: string;
  iosPath: string;
  assetId: string;
  preloaded: boolean;
}

const SOUNDS: { [key in SoundIds]: Sound } = {
  BEEP: {
    androidPath: 'public/assets/sounds/beep.mp3',
    iosPath: 'public/assets/sounds/beep.mp3',
    webPath: 'beep.mp3',
    assetId: 'beep',
    preloaded: false,
  },
  HOOYAH: {
    androidPath: 'public/assets/sounds/hooya.mp3',
    iosPath: 'public/assets/sounds/hooya.mp3',
    webPath: 'hooyah.mp3',
    assetId: 'hooyah',
    preloaded: false,
  },
};

export function useSound() {
  async function play(soundId: SoundIds) {
    const s = SOUNDS[soundId];
    const platform = Capacitor.getPlatform();
    const assetPath = platform === 'android' ? s.androidPath : platform === 'ios' ? s.iosPath : s.webPath;
    if (!s.preloaded) {
      try {
        await NativeAudio.preload({ assetId: s.assetId, assetPath, volume: 0.5 });
      } catch (e) {
        console.log('Error preloading audio', e);
      }
      s.preloaded = true;
    }
    try {
      await NativeAudio.play({ assetId: s.assetId });
    } catch (e) {
      console.log('Error playing audio', e);
    }
  }

  return {
    play,
  };
}
